export const isOK = (status) => (status === 200 || status === 201)